// extracted by mini-css-extract-plugin
export var content = "Footer-module--content--A1dSL";
export var bold = "Footer-module--bold--P7VcL";
export var spacer = "Footer-module--spacer--ciJmG";